import { render, staticRenderFns } from "./DoctorTab.vue?vue&type=template&id=e83d0580&scoped=true&"
import script from "./DoctorTab.vue?vue&type=script&lang=js&"
export * from "./DoctorTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83d0580",
  null
  
)

export default component.exports